import {
  updateMeasureDefaults,
  uploadCropPictureOptions,
} from '@lidea/shared/data-access/analysis';
import { MutationWithContext } from '@lidea/shared/data-access/core';
import { Box } from '@mantine/core';
import { hashKey } from '@tanstack/react-query';

import { UpdateMeasurePreview } from './mutations/update-measure';

interface MutationPreviewProps {
  mutation: MutationWithContext;
  fieldId: number;
}

export const MutationPreview: React.FC<MutationPreviewProps> = ({
  mutation,
  fieldId,
}) => {
  if (!mutation.options.mutationKey) {
    return null;
  }

  if (
    hashKey(mutation.options.mutationKey) ===
      hashKey(updateMeasureDefaults.mutationKey) &&
    mutation.state.variables &&
    'id' in (mutation.state.variables as any)
  ) {
    return (
      <Box p="sm">
        <UpdateMeasurePreview
          fieldId={fieldId}
          measureId={(mutation.state.variables as { id: number }).id}
          mutation={mutation}
        />
      </Box>
    );
  }

  if (
    hashKey(mutation.options.mutationKey) ===
      hashKey(uploadCropPictureOptions.mutationKey) &&
    mutation.state.variables &&
    ((mutation.state.variables as { picture?: File }).picture ||
      (mutation.state.variables as { pictureId?: string }).pictureId)
  ) {
    const file = (mutation.state.variables as { picture?: File }).picture;
    if (!file) {
      return null;
    }
    return <img alt="Preview" src={URL.createObjectURL(file)} />;
  }

  return null;
};
